import {
  Button,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  Nav,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import "./MenuTop.css";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { UserToken } from "../../context/hooks/useAuth";
import { jwtDecode } from "jwt-decode";

const MenuTop = () => {
  const { handleLogout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 650);

  const tokenLocal = localStorage.getItem("token");

  let objUserTk: UserToken;
  if (tokenLocal) {
    objUserTk = jwtDecode(tokenLocal) as UserToken;
  } else {
    objUserTk = {} as UserToken;
  }

  const navigate = useNavigate();

  const exit = async () => {
    await handleLogout();
    navigate("/auth/login");
  };

  const toMyDocuments = async () => {
    navigate("/admin/my-documents");
  };

  const toHome = async () => {
    navigate("/admin/index");
  };

  const toMyProfile = async () => {
    navigate("/admin/profile");
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 650);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Row
        className="header"
        style={{
          margin: 0,
          backgroundColor: "#fff",
          alignItems: "center",
          position: "relative",
        }}
      >
        {(isMenuOpen || !isMobileView) && (
          <Col
            className={`menu-container mt-4 mb-4 ${
              isMenuOpen ? "menu-open" : "menu-closed"
            }`}
            >
            <img
            style={{marginRight: "43px"}}
              className="profile-photo-navbar"
              alt="Avatar"
              src={require("../../assets/img/theme/icp.png")}
            />
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <div className="card-profile-image">
                    <a href="" onClick={(e) => e.preventDefault()}>
                      <div className="card-candidate-content">
                        <div className="card-profile-image-recruiter ">
                          <img
                            className="profile-photo-navbar"
                            alt="Avatar"
                            src={require("../../assets/img/theme/profile.png")}
                          />
                        </div>
                      </div>
                    </a>
                  </div>
                  <Media className="ml-2 d-lg-block">
                    <span className="mb-0 text-sm" style={{ color: "#F9B233" }}>
                      <span className="mobile">
                        {objUserTk.UserName || "User"}
                      </span>
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Bem vindo!</h6>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => handleLogout()}>
                  <i className="ni ni-user-run" />
                  <span>Sair</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>

            {/* <Button className="button-route-sid" onClick={exit}>
              <ExitToAppOutlinedIcon
                style={{ color: "#DCAC36", marginRight: "5px" }}
              />
              <span style={{ color: "#222222" }}>Sair</span>
            </Button> */}
          </Col>
        )}
      </Row>
    </>
  );
};

export default MenuTop;
